<template>
  <div class="body">
      <Headtow></Headtow>
      <div id="w-center">
        <div id="Breadcrumb">
          <i class="el-icon-house Breadcrumb-i" ></i>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>行业资讯</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- 左侧 -->
        <div class="w-products" v-loading="loading">
          <div id="content">
              <p class="news-title">{{info.title}}</p>
              <p class="news-bq">发布时间: {{info.create_time}}&nbsp;&nbsp;&nbsp;作者：{{info.fbname}}
              <span style="display: inline-block;">
                <el-popover
                    placement="right"
                    :v-model="false"
                    width="120"
                    trigger="click">
                    <div id="qrcode"  />
                    <div slot="reference" class="div-fx div-fx-hehe"><img src="/static/img/wx.png" alt="">微信分享</div>
                    <!-- <el-button slot="reference">click 激活</el-button> -->
                  </el-popover>
              </span>

                </p>
              <div id="content">
                <div v-html="info.content"></div>
              </div>
          </div>
        </div>
        <!-- 左侧结束 -->
        <!-- 右侧开始 -->
         <div id="products-right">
             <p class="products-right-title">行业资讯</p>
             <ul class="products-right-ul" v-loading="loading">
               <li class="ov1" v-for="(item, index) in left" :key="item.id">
                 <a @click="getCont(item.id)">
                    {{item.title}}
                </a>
               </li>
             </ul>
         </div>
        <!-- 右侧结束 -->
      </div>
	  <div id="qrcode"></div>
       <Foot></Foot>
  </div>

</template>

<script>
import QRCode from 'qrcode2';

import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      info:[],
      left:{},
      id:'',

     }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,

  },
  mounted () {
    this.id = this.$route.query.id;
    setTimeout(() => {
    	let shareUrl = "http://touch.zyjlfwpt.com/NewsCont?id="+this.id;
    	let qrcode = new QRCode("qrcode", {
    	  text: shareUrl,
    	  width: 120, //图像宽度
    	  height: 120, //图像高度
    	});
    qrcode.clear(); //清除二维码
    	 qrcode.makeCode(shareUrl); //生成另一个新的二维码
      }, 100);
    console.log(this.id);


    console.log(this.id);
    this.recordapi();
  },
  methods:{

   recordapi(){
       var that = this;
       var userid = that.$cookieStore.getCookie('userid');
       that.$api.post("/Products/NewsCont",{'id':that.id,userid:userid}).then(res => {
         console.log(res);
         that.info= res.info;
         that.left= res.left;
         that.loading = false
       });
   },
    getCont(id){
      this.id=id;
      this.recordapi();
    },
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/NewsCont.vue